import { render, staticRenderFns } from "./TabReversal.vue?vue&type=template&id=31c390a0"
import script from "./TabReversal.vue?vue&type=script&lang=js"
export * from "./TabReversal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports